import { merge } from "lodash-es";
import { sharedTranslations } from "../../shared-translations.js";
import { sunsetSpecificTranslations, type ISunsetSpecificTranslations } from "../sunset/index.js";

export const holistoSpecificTranslations = {
  title: "Always getting you </br> a better hotel deal",
  "top-destinations-title": "Top Destinations",
  "install-button-text": "Install",
  "mobile-app-header": "Unparalleled deals at your fingertips",
  "mobile-app-description":
    "Keep Holisto’s technology with you, enabling you to find the best possible hotel deals no matter where you’re at.",
  "get-app": "Get the app",
} as const;
export type IHolistoSpecificTranslations = typeof holistoSpecificTranslations & ISunsetSpecificTranslations;

const holistoTranslations = merge({}, sharedTranslations, holistoSpecificTranslations, sunsetSpecificTranslations);
export const translations = {
  dictionary: holistoTranslations,
  language: "EN",
};
